import React, {useEffect, useState} from "react";
import "./RaikoCustomEditorStyleSheet.scss"
import {css} from "@emotion/css";
import {RaikoCustomEditorUtils} from "./RaikoCustomEditorUtils";
import RaikoTextEditor from "../raikoTextEditor/RaikoTextEditor";
import FileManager, {FileManagerTypes} from "../../component/fileManager/FileManager";
import RaikoDefaultDialogPage, {DialogSize} from "../../component/defaultDialogPage/RaikoDefaultDialogPage";
import {useAuthState} from "../../context/AuthContext";
import {HttpClient} from "../../service/httpClient/HttpClient";
import trashIcon from "../../assets/svg/trash.svg"

const RaikoCustomEditor = (
    {
        defaultEditorData,
        setLastEditorData,
        fileManagerTypes = FileManagerTypes.POST_THUMBNAILS
    }) => {

    const [editorData, setEditorData] = useState([]);
    const raikoCustomEditorUtils = new RaikoCustomEditorUtils();

    useEffect(() => {
        if (typeof defaultEditorData !== "undefined" && defaultEditorData.length > 0) {
            setEditorData(defaultEditorData)
        }
    }, [defaultEditorData])

    useEffect(() => {
        if (typeof editorData !== 'undefined') {
            setLastEditorData(editorData)
        }
    }, [editorData])

    const [imageUrl, setImageUrl] = useState("");
    const [imageId, setImageId] = useState(-1);
    const [selectedImageItem, setSelectedImageItem] = useState(null);
    const [openGalleryDialog, setOpenGalleryDialog] = useState(false);
    const [isSlider, setIsSlider] = useState(false);

    function handleCloseGalleryDialog() {
        setOpenGalleryDialog(false)
    }

    function handleOpenGalleryDialog(item) {
        setSelectedImageItem(item)
        setOpenGalleryDialog(true)
        setIsSlider(false)
    }

    function handleSelectSliderItemOpenGalleryDialog(item) {
        setSelectedImageItem(item)
        setOpenGalleryDialog(true)
        setIsSlider(true)
    }

    function handleDeleteSliderItem(item, position,id, imageId) {
        let _amount = []
        item.content.amount.map((item, index) => {
            if (item !== id) {
                _amount.push(item)
            }
        })

        item.content.amount = _amount

        document.getElementById(imageId).style.display = "none"

    }

    function handleSelectImageUrl(id, url) {
        if (isSlider) {
            selectedImageItem.content.amount.push(id)
        } else {
            selectedImageItem.content.amount = id
        }
    }

    /* function loadImageFromUrl(item, imageId) {
         ImageLoader(item.content.amount, token)
             .then(response => {
                 document.getElementById(imageId).src = response;
                 item.content.loadedImage = response
             }).catch(reason => {
             console.log("error in get image ", reason)
         })
     }*/


    /*function loadSliderImageFromUrl(item, imageItem, index, imageId) {

        ImageLoader(imageItem, token)
            .then(response => {
                document.getElementById(imageId).src = response;
                // item.content.loadedImage = response
            }).catch(reason => {
            console.log("error in get image ", reason)
        })
    }*/

    function loadImage(imageId, id) {
        new HttpClient()
            .get(
                `files/${id}/urls/public`
            ).then(response => {
            document.getElementById(imageId).src = response.url;

        }).catch(reason => {

            console.log("image not loading by reason ", reason)
        })

        return ""
    }

    return (
        <>
            <RaikoDefaultDialogPage
                onClose={handleCloseGalleryDialog}
                open={openGalleryDialog}
                dialogSize={DialogSize.LARGE}
                pageTitle={fileManagerTypes.name}
            >
                <FileManager
                    isDialog={true}
                    setOpenDialog={setOpenGalleryDialog}
                    defaultGalleryType={fileManagerTypes}
                    setSelectedFileUrl={handleSelectImageUrl}
                />

            </RaikoDefaultDialogPage>

            <div className={`baseEditorContainer`}>

                <span className={`baseEditorTitle`}>توضیحات</span>

                <div className={`editorContainer`}>
                    {raikoCustomEditorUtils.insertInterface(0, editorData, setEditorData, true)}

                    {typeof editorData === "undefined" || editorData.length === 0 &&
                        <div className={css`
                          border: 1px solid var(--header-border-bottom-color);
                          transition: var(--base-transition);
                          border-radius: var(--default-border-radius);
                          padding: 1rem;
                        `}>
                            <p className={css`color: var(--color-variant);
                              text-align: center;
                              width: 100%;
                              font-size: var(--text-size-default)`}>
                                ابتدا یکی از انواع محتوای فوق را انتخاب نمایید...
                            </p>
                        </div>
                    }

                    {editorData && editorData.map((item, index) => {
                        switch (item.content.type) {
                            case raikoCustomEditorUtils.editorItemType.HTML: {
                                return <div className={`editorItemContainer`} key={index}>
                                    <div className={`editorItem`}>
                                        <RaikoTextEditor
                                            text={item.content.amount}
                                            setText={text => {
                                                item.content.amount = text
                                            }}
                                        />
                                        {raikoCustomEditorUtils.deleteInterface(index, editorData, setEditorData)}
                                    </div>
                                    {raikoCustomEditorUtils.insertInterface(index, editorData, setEditorData)}
                                </div>
                            }
                            case raikoCustomEditorUtils.editorItemType.IMAGE: {
                                return <div className={`editorItemContainer`} key={index}>
                                    <div className={`editorItem`}>

                                        <div className="editorItemImageContainer"
                                             onClick={_ => handleOpenGalleryDialog(item)}
                                        >
                                            {
                                                item.content && item.content.amount ?
                                                    <img
                                                        alt={`image-${index}`}
                                                        id={`image-${index}`}
                                                        src={loadImage(`image-${index}`, item.content.amount)}
                                                    /> :
                                                    <div>
                                                        <div
                                                            className={`editorIcon pictureIcon-icon`}
                                                        />
                                                    </div>
                                            }
                                            <span
                                                className="fs-1 mt-2">
                                                {item.content.amount ? "برای تغییر تصویر کلیک کنید." : "عکس مورد نظر خود را انتخاب نمایید."}
                                            </span>
                                        </div>


                                        {raikoCustomEditorUtils.deleteInterface(index, editorData, setEditorData)}
                                    </div>
                                    {raikoCustomEditorUtils.insertInterface(index, editorData, setEditorData)}
                                </div>
                            }
                            case raikoCustomEditorUtils.editorItemType.IMAGE_SLIDER: {
                                return <div className={`editorItemContainer`} key={index}>
                                    <div className={`editorItem`}>

                                        <div className="editorItemSliderContainer">
                                            <div className={css`
                                              display: flex;
                                              flex-direction: row;
                                              flex-wrap: wrap;
                                              gap: 16px;
                                              width: 100%;
                                              overflow: hidden;
                                              padding: 0 16px;
                                              justify-content: center;
                                              align-items: center;
                                            `}>
                                                {item.content.amount.length > 0 ?
                                                    item.content.amount.map((imageItem, sliderIndex) => {
                                                        return <div
                                                            onClick={_ => {
                                                                handleDeleteSliderItem(item, sliderIndex,imageItem, `slider-image-${index}-${sliderIndex}`)
                                                            }}
                                                            className={"sliderImageContainer"}>
                                                            <img
                                                                alt={`slider-image-${index}-${sliderIndex}`}
                                                                id={`slider-image-${index}-${sliderIndex}`}
                                                                src={loadImage(`slider-image-${index}-${sliderIndex}`, imageItem)}
                                                            />
                                                            <div className={"trashIconContainer"}>
                                                                <div className={`trash-icon
                                                                    ${css`
                                                                  width: 32px;
                                                                  height: 32px;
                                                                  background-color: #FFF;
                                                                `}
                                                                `}/>
                                                            </div>
                                                        </div>
                                                    }) : ""
                                                }

                                                <div className={`add-image-icon cursorPointer`}
                                                     onClick={_ => handleSelectSliderItemOpenGalleryDialog(item)}
                                                />

                                            </div>
                                            <span
                                                className={css`font-size: 14px;
                                                  margin-top: 1rem;`}>{"تصاویر اسلایدر را به ترتیب انتخاب نمایید."}</span>
                                        </div>


                                        {raikoCustomEditorUtils.deleteInterface(index, editorData, setEditorData)}
                                    </div>
                                    {raikoCustomEditorUtils.insertInterface(index, editorData, setEditorData)}
                                </div>
                            }
                        }
                    })}
                </div>
            </div>
        </>
    )
}
export default RaikoCustomEditor